import { Button } from "@mui/material";
import { AxiosError } from "axios";
import React, { useEffect, useMemo, useState } from "react";
import LoginIcon from "@mui/icons-material/Login";
import "./TGN_Login.scss";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Input } from "../../hookFormComponents.tsx/Input";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/api";

type Props = { setToken: React.Dispatch<React.SetStateAction<string | null>> };

const Login = ({ setToken }: Props) => {
  const validationSchema = Yup.object({
    email: Yup.string().required("Required").email("Invalid Email"),
    password: Yup.string().required("Required").min(6, "Minumum 6 characters"),
  });

  const {
    formState: { errors },
    control,
    setValue,
    register,
    handleSubmit,
    getValues,
  } = useForm<Yup.InferType<typeof validationSchema>>({
    resolver: yupResolver(validationSchema),
  });

  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState<string | null>(null);

  const navigate = useNavigate();
  // useEffect(() => {
  //   localStorage.setItem("token","eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjIsImRhdGEiOnsiaWQiOjIsImZpcnN0X25hbWUiOiIyMzQyMzQyMzQiLCJsYXN0X25hbWUiOiIyMzQyMzQiLCJlbWFpbCI6ImFhYWtvc3RhMTExMUBnbWFpbC5jb20iLCJwYXNzd29yZCI6IiQyYiQxMCRWei9lUmJtR0NNZThnQkhOLko3bk9lYVk4STloRlU2aFhaelU1OE5UZHhPRC9YU2lTS2pEZSIsInBob25lIjo0MjM0MjM0MjMsInZlcmlmaWNhdGlvbl91cmwiOm51bGwsImlzX3ZlcmlmaWVkIjowLCJjcmVhdGVkX2F0IjoiMjAyNC0xMS0yOFQxMDo1NTo1MC4wMDBaIiwidXBkYXRlZF9hdCI6IjIwMjQtMTEtMjhUMTE6MjY6NDUuMDAwWiIsInJvbGUiOiJBcHAgQWRtaW4iLCJ0b2tlbiI6ImV5SmhiR2NpT2lKSVV6STFOaUo5LmEyOXpkR0ZBWjIxaGFXd3VZMjl0Llp3VDgyRW9qNU9OajVkTXl4SkNWdDZPYk5ueWVKVnlhcHdSZy1fRlBzMTgiLCJkZWxldGVkX2F0IjpudWxsLCJtYXhfYm9va2luZ3MiOjQsInVzZXJuYW1lIjoiMjM0MjM0MjMifSwiaWF0IjoxNzMyNzk0MTU1LCJleHAiOjE3MzI3OTU5NTV9.L0cbCI_1sxo1kqGck3d6kO23a9KBhlGGfuqZG9d1Yac")
  // }, []);

  return (
    <form
      noValidate
      onSubmit={handleSubmit((values) => {
        setIsLoading(true);
        setLoginError(null);
        api
          .post(`/auth/admin_login`, values)
          .then((res) => {
            localStorage.setItem("token", res.data.token);
             setToken(res.data.token);
            console.log("evo mee");
            console.log(res.data.token)
            setIsLoading(false);
            navigate("/users");
            // window.location.reload();
          })
          .catch((e: AxiosError) => {
            console.log(e);
            setIsLoading(false);
            const status = e.response?.status;
            setLoginError(
              status === 403
                ? "You don't have permission to access the admin app."
                : "Invalid email or password."
            );
          });
      })}
    >
      <div className="login-wrapper">
        <div className={"inner-wrapper"}>
          <div className={"title-wrapper"}>
            <div className="title-wrapper-inner">
              <h2 className={"title"}>Login</h2>

              <Input
                required
                {...register("email")}
                label={"email"}
                type="text"
                error={errors?.email?.message}
              />
              <Input
                required
                {...register("password")}
                label={"password"}
                type="password"
                error={errors?.password?.message}
              />
              <Button
                type="submit"
                variant="contained"
                startIcon={<LoginIcon />}
              >
                Log In
              </Button>
              {loginError && (
                <div style={{ color: "red", marginTop: 8, fontSize: 13 }}>
                  {loginError}
                </div>
              )}

              {/* <a
                className="forgot-password"
                onClick={() => this.setState({ openForgotPasswordModal: !this.state.openForgotPasswordModal })}
              >
                {t('forgotPassword')}
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Login;
